import {
  indicativeRepaymentOptionsDecoder,
  indicativeRepaymentOptionsPostJsonEncoder,
} from "decoders/calculateIndicativeRepaymentOptions";
import { AboutYourLoan } from "domain/aboutYourLoan";
import { IndicativeRepaymentOptions } from "domain/indicativeRepaymentOptions";
import { envSettings } from "./envService";
import { createPost } from "./fetchService";
import { handleResponse } from "./util";

const { serviceHost } = envSettings();

export const postCalculateIndicativeRepaymentOptions = async (
  aboutYourLoan: AboutYourLoan
): Promise<IndicativeRepaymentOptions> => {
  const post = createPost();
  const payload = indicativeRepaymentOptionsPostJsonEncoder(aboutYourLoan);
  const response = await post(
    `${serviceHost}/calculateIndicativeRepaymentOptions`,
    payload
  );
  return handleResponse(indicativeRepaymentOptionsDecoder, response);
};
